import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "src/components/Link";
import { ActionBanner } from "src/components/ActionBanner";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { PATHNAMES } from "src/constants/routes";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus.svg";
import { emptyCloneListTrns, myClonesTrns } from "./trns";

export const EmptyCloneList: FC = () => {
  const { t } = useTranslation();

  return (
    <ActionBanner title={t(emptyCloneListTrns.title)}>
      <p>{t(emptyCloneListTrns.description)}</p>
      <Button variant={ButtonVariants.SECONDARY} className="!p-0">
        <Link
          href={PATHNAMES.CREATE_CLONE}
          className="flex items-center justify-center gap-2 py-2 px-5 font-medium"
        >
          <PlusIcon />
          <span>{t(myClonesTrns.createCloneButton)}</span>
        </Link>
      </Button>
    </ActionBanner>
  );
};
